// import React, { useContext, useState } from 'react';
// import api from '../../../api/axiosConfig';
// import { AuthContext } from '../../../context/AuthContext';
// import { useNavigate, Link } from 'react-router-dom';
// import type { LoginResponse } from '../../../types/api';
// import type { UserRole } from '../../../types';
// import '../../../styles/forms.css';
// import Navbar from '../homePage/Navbar';
// // import TopBar from '../homePage/TopBar';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

// const Login: React.FC = () => {
//   const [emailOrPhone, setEmailOrPhone] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [toast, setToast] = useState<{ type: 'error'; message: string } | null>(null);

//   const context = useContext(AuthContext);
//   const navigate = useNavigate();

//   if (!context) return null;
//   const { login } = context;

//   const handleLogin = async () => {
//     if (!emailOrPhone) {
//       setToast({ type: 'error', message: 'Email or Phone is required' });
//       setTimeout(() => setToast(null), 5000);
//       return;
//     }

//     const isFarmer = /^\d+$/.test(emailOrPhone);

//     if (isFarmer) {
//       if (emailOrPhone.length !== 10) {
//         setToast({ type: 'error', message: 'Phone Number must be a 10 digit number' });
//         setTimeout(() => setToast(null), 5000);
//         return;
//       }
//     } else {
//       if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailOrPhone)) {
//         setToast({ type: 'error', message: 'Invalid email format' });
//         setTimeout(() => setToast(null), 5000);
//         return;
//       }
//     }

//     if (!password) {
//       setToast({ type: 'error', message: 'Password is required' });
//       setTimeout(() => setToast(null), 5000);
//       return;
//     }

//     if (password.length < 8) {
//       setToast({ type: 'error', message: 'Password must be 8 or more characters' });
//       setTimeout(() => setToast(null), 5000);
//       return;
//     }

//     try {
//       const endpoint = isFarmer ? 'loginAnimal' : 'login';
//       const payload = isFarmer
//         ? { owner_phone: emailOrPhone, owner_password: password }
//         : { user_email: emailOrPhone, user_password: password };

//       const res = await api.auth_api.post<LoginResponse>(`/auth/${endpoint}`, payload);
  
//       if(isFarmer){
//         login({
//           role: 'owner' as UserRole,
//           ...(res as any).data.owner
//         });
//       } else {
//         login({
//           role: res.data.user.user_role as UserRole,
//           ...(res as any).data.user
//         });
//       }

//         navigate(isFarmer ? '/farmer' : res.data.user.user_role === "admin" ? '/admin' : res.data.user.user_role === "vendor" ? '/vendor' : res.data.user.user_role === "doctor" ? '/doctor' : res.data.user.user_role === "organisation" ? '/organisation' : res.data.user.user_role === "hospital" ? '/hospital' : res.data.user.user_role === "Animal Enthusiasts" ? '/enthusiasts' : res.data.user.user_role === "lab" ? '/lab' : '/register');
//       } catch (error) {
//     setToast({ type: 'error', message: 'Login failed! Incorrect Email or Password' });
//     setTimeout(() => setToast(null), 5000);
//   }

//   };

//   return (
//     <>
//       {/* <TopBar/> */}
//       <Navbar />

//       {toast && (
//       <div className={`global-toast ${toast.type}`}>
//         <span>{toast.message}</span>
//         <button
//           className="toast-close"
//           onClick={() => setToast(null)}
//           aria-label="Close"
//         >
//           ×
//         </button>
//       </div>
//     )}

//       <div className="center-page-lr">
//         <div className="form-container">
//           <h2 className="form-title1">Login</h2>
//           <div className="form-group">
//             <input 
//               className="form-input"
//               value={emailOrPhone} 
//               onChange={(e) => setEmailOrPhone(e.target.value)} 
//               placeholder="Email or Phone" 
//             />
//           </div>
//           <div className="form-group">
//             <div style={{ position: 'relative', width: '100%' }}>
//               <input 
//                 className="form-input"
//                 type={showPassword ? "text" : "password"}
//                 // style={{ width: '100%', boxSizing: 'border-box', paddingRight: '40px' }}
//                 value={password} 
//                 onChange={(e) => setPassword(e.target.value)} 
//                 placeholder="Password" 
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowPassword(!showPassword)}
//                 style={{
//                   position: 'absolute',
//                   right: '10px',
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   background: 'transparent',
//                   border: 'none',
//                   cursor: 'pointer',
//                   color: '#666',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   padding: 0
//                 }}
//               >
//                 {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//               </button>
//             </div>
//           </div>
//           <button className="form-button" onClick={handleLogin}>Login</button>
//           <div className="form-footer">
//             <p>Don't have an account? <Link to="/register">Register here</Link></p>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Login;







import React, { useContext, useState } from 'react';
import api from '../../../api/axiosConfig';
import { AuthContext } from '../../../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import type { LoginResponse } from '../../../types/api';
import type { UserRole } from '../../../types';
import '../../../styles/forms.css';
import Navbar from '../homePage/Navbar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const PHONE_PATTERN = /^\d{10}$/;

const getDashboardPath = (role: UserRole): string => {
  const dashboardPaths: Partial<Record<UserRole, string>> = {
    owner: '/farmer',
    admin: '/admin',
    vendor: '/vendor',
    doctor: '/doctor',
    organisation: '/organisation',
    hospital: '/hospital',
    'Animal Enthusiasts': '/enthusiasts',
    lab: '/lab',
  };

  return dashboardPaths[role] ?? '/register';
};

const Login: React.FC = () => {
  const [emailOrPhone, setEmailOrPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState<{ type: 'error'; message: string } | null>(null);

  const context = useContext(AuthContext);
  const navigate = useNavigate();

  if (!context) return null;
  const { login } = context;

  const showError = (message: string) => {
    setToast({ type: 'error', message });
    setTimeout(() => setToast(null), 5000);
  };

  const handleLogin = async () => {
    const identifier = emailOrPhone.trim();

    if (!identifier) {
      showError('Email or Phone is required');
      return;
    }

    const isEmail = identifier.includes('@');
    const normalizedIdentifier = isEmail
      ? identifier.toLowerCase()
      : identifier.replace(/\D/g, '');

    if (isEmail && !EMAIL_PATTERN.test(normalizedIdentifier)) {
      showError('Invalid email format');
      return;
    }

    if (!isEmail && !PHONE_PATTERN.test(normalizedIdentifier)) {
      showError('Phone Number must be a 10 digit number');
      return;
    }

    if (!password) {
      showError('Password is required');
      return;
    }

    if (password.length < 8) {
      showError('Password must be 8 or more characters');
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await api.auth_api.post<LoginResponse>('/auth/login', {
        identifier: normalizedIdentifier,
        password,
      });

      if (response.data.account_type === 'owner' && response.data.owner) {
        login({
          role: 'owner',
          ...response.data.owner,
        });
        navigate('/farmer');
        return;
      }

      if (response.data.account_type === 'service' && response.data.user) {
        const role = response.data.user.user_role as UserRole;
        login({
          role,
          ...response.data.user,
        });
        navigate(getDashboardPath(role));
        return;
      }

      showError('Login response was invalid. Please try again.');
    } catch (error: any) {
      showError(
        error?.response?.data?.message ||
          'Login failed. Please check your email or phone and password.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />

      {toast && (
        <div className={`global-toast ${toast.type}`}>
          <span>{toast.message}</span>
          <button
            className="toast-close"
            onClick={() => setToast(null)}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      )}

      <div className="center-page-lr">
        <div className="form-container">
          <h2 className="form-title1">Login</h2>
          <div className="form-group">
            <input
              className="form-input"
              value={emailOrPhone}
              onChange={(event) => setEmailOrPhone(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' && !isSubmitting) handleLogin();
              }}
              placeholder="Email or Phone"
              autoComplete="username"
            />
          </div>
          <div className="form-group">
            <div style={{ position: 'relative', width: '100%' }}>
              <input
                className="form-input"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' && !isSubmitting) handleLogin();
                }}
                placeholder="Password"
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#666',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                }}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </button>
            </div>
          </div>
          <button
            className="form-button"
            onClick={handleLogin}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Logging in...' : 'Login'}
          </button>
          <div className="form-footer">
            <p>
              Don't have an account? <Link to="/register">Register here</Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
